module.exports = __webpack_public_path__ + "img/tx_002.fb4646a9.png";